import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "src/store/actions/action";
import Body from "src/components/common/Body";
import Button from "src/components/common/Button";
import Box from "src/components/common/Box";
import SearchInput from "src/components/common/SearchInput";
import Chip from "src/components/common/Chip";
import cn from "classnames";
import styled from "styled-components";
import { BLOCKED_USER, SOS_NOTICE_LIST, sosListDelete, sosListSet } from "../../utils/sosFunc";

function UserBlock() {
  const navigate = useNavigate();
  const noticeListReduce = useAppSelector((state) => state.noticeListReduce);
  const [hasAlarm, setHasAlarm] = useState(false);

  // 제목 키워드 검색
  const [searchKeyword, setSearchKeyword] = useState(noticeListReduce.keywordSearchData ? noticeListReduce.keywordSearchData : "");
  const [blockList, setBlockList] = useState<string[]>([]);
  const deleteSelected = (v: string, i: number) => {
    if (window.localStorage.getItem(BLOCKED_USER)) {
      const result = sosListDelete(BLOCKED_USER, v);
      setBlockList(result ? result : []);
    }
  };
  const onSearchKeywords = (e: any) => {
    if (e.currentTarget.parentElement?.childNodes[0].value.trim().length == 0) {
      return;
    }
    const id = e.currentTarget.parentElement?.childNodes[0].value;
    sosListSet(BLOCKED_USER, id);

    const sosData: { list: string[] | undefined } | undefined = JSON.parse(window.localStorage.getItem(BLOCKED_USER)!);
    setBlockList(sosData?.list ? sosData?.list : []);
  };

  // 키워드 엔터로 검색
  const onKeyPress = (e: any) => {
    if (e.key === "Enter") {
      onSearchKeywords(e);
    }
  };

  // 검색어 삭제
  const deleteSearchContents = () => {
    console.log();
  };

  useEffect(() => {
    if (window.localStorage.getItem(BLOCKED_USER)) {
      const sosData: { list: string[] | undefined } | undefined = JSON.parse(window.localStorage.getItem(BLOCKED_USER)!);
      setBlockList(sosData?.list ? sosData?.list : []);
    }
  }, []);
  return (
    <>
      <header className={cn({ hasAlarm: hasAlarm })}>
        <div>
          <Button variant="text" className="btn-back" onClick={() => navigate(-1)}>
            사용자 차단
          </Button>
        </div>
      </header>

      <Body isTabbar={true}>
        <Box pd="20px 15px">
          <SearchInput
            type="text"
            id="search-input"
            placeholder="차단할 아이디를 등록해주세요."
            defaultValue={searchKeyword}
            onClick={(e) => onSearchKeywords(e)}
            onKeyPress={(e) => onKeyPress(e)}
            deleteSearchContentFunc={deleteSearchContents}
          />
        </Box>
        <FilterBtnSet>
          {blockList.map((v: any, i: number) => {
            return (
              <Chip variant="contained" deleted={true} key={i} onDelete={() => deleteSelected(v, i)}>
                {v}
              </Chip>
            );
          })}
        </FilterBtnSet>
      </Body>
    </>
  );
}

const FilterBtnSet = styled.div`
  overflow: hidden;
  overflow-x: scroll;
  width: 100%;
  padding: 15px;
  border-top: 1px solid ${({ theme }) => theme.color.linePrimary};
  border-bottom: 1px solid ${({ theme }) => theme.color.linePrimary};
  ${({ theme }) => theme.flexBox.flexMixin("row", "flex-start")}
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera*/
  }
  > * {
    flex: 0 0 auto;
    margin-right: 10px;
    &:last-child {
      margin-right: 0;
    }
  }
  > button {
    > svg {
      position: relative;
      top: -1px;
    }
  }
  .only-new {
    > svg {
      top: 2px;
      left: 2px;
    }
  }
`;

export default UserBlock;
